import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, of } from 'rxjs';
import { AvatarService } from "./services/avatar.service";

@Component({
  selector: 'core-plugin-lib-user-avatar',
  imports: [CommonModule],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAvatarComponent implements OnInit {

	private readonly avatarService = inject(AvatarService);

	@Input() email: string | undefined;
	@Input() name: string | undefined;
	@Input() internalAvatarUrl: string | null | undefined; // URL to internal avatar
	@Input() size: number = 40;

	avatarUrl$: Observable<string | null> = of(null);
	altText: string = 'User avatar';

	ngOnInit(): void {
		this.altText = this.name ? `${this.name}'s avatar` : 'User avatar';

		if (!this.email) {
			return;
		}

		// Get avatar with priority: internal > gravatar (if enabled) > null
		this.avatarUrl$ = this.avatarService.getAvatarUrl(
			this.email,
			this.internalAvatarUrl,
			this.size
		);
	}

	getInitials(): string {
		if (this.name) {
			const names = this.name.split(' ').filter(n => n.length > 0);
			if (names.length >= 2) {
				return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
			}
			if (names.length === 1) {
				return names[0][0].toUpperCase();
			}
		}
		if (this.email) {
			return this.email[0].toUpperCase();
		}
		return '?';
	}

	onImageError(): void {
		console.debug('Failed to load avatar image');
	}
}
